<template>
    <ui-modal
        v-show="visible"
        :name="$mx_getModalName"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        :title="modalTitle"
        :size="modalSize"
        :show-close-option="false"
		@close="handleClose"
        icon="fal fa-building"
        custom-loader
    >
        <template #custom-loader>
            <ui-loader-message
                :message="loader.modalMessage"
                :description="loader.modalDescription"
                :loading="loader.modalLoad"
                :success="loader.modalLoadSuccess"
                :failed="loader.modalLoadFailed"
                :close-action="customClose"
            >
                <template v-if="!noFinalize" #success>
                    <div class="success-actions">
                        <ui-actions-deals-wrapper-list v-model="actionList" />
                    </div>

                    <ui-button
                        v-if="loader.modalLoadSuccess"
                        design="md primary"
                        :disabled="!successAction"
                        @click="successButton">
                        Avançar
                    </ui-button>
                </template>

                <template #failed>
                    <ui-button
                        v-if="loader.modalLoadFailed"
                        design="xs primary"
                        @click="refreshUnits()">
                        Tentar novamente
                    </ui-button>
                </template>
            </ui-loader-message>
        </template>

        <section class="reserve-container" :class="{ 'has-actions':  actionVisible }">
            <div class="select-block">
                <div class="select-content">
                    <ui-deal-selector
                        v-model="form.deal"
                        return-value="object"
                        design="br-default"
                        cancel-event="request-reserve"
                        :disabled="cantSelectDeal"
                        :is-iframe="iframe"
                    />
                </div>

                <div class="select-content product-form">
                    <ui-nugget-product-form
                        v-model="form.productForm"
                        :fetch-list.sync="form.productOptions"
                        :loader-list.sync="productLoader"
                        :show-customs="stages.second"
                        nugget-id="select-reserve-modal"
                        needs-reset
                    />

                    <div
                        v-show="actionVisible"
                        class="action-nugget"
                    >
                        <ui-nugget-actions-sage-status
                            v-model="action"
                            :visible.sync="actionVisible"
                            action-type="make_reserve"
                            nugget-id="request-reserve-modal"
                            design="grid-2"
                        />
                    </div>
                </div>

                <div
                    v-if="!$mx_userIsBroker && form.expireTimes.length > 0 && stages.second"
                    class="select-content expire-time"
                >
                    <ui-select-v2
                        v-model="form.expireTime"
                        :data="form.expireTimes"
                        label="Tempo de expiração:"
                        item-label="time"
                        return-value="time"
                        design="br-default"
                    />
                </div>
            </div>

            <div v-if="stages.second" class="wrapper-block">
                <ui-reserve-wrapper-list
                    v-model="getAllUnits"
                    :loading="productLoader.units"
                    :info="form.info"
                />
            </div>
        </section>

        <template #footer>
            <ui-switch
                v-if="stages.second && switchActive"
                class="reserve-switch"
                label="Exibir unidades reservadas"
                design="xs primary"
                :checked="showReserved"
                @input="showReservedInput"
            />

            <div class="cancel-buttons">
                <ui-button
                    type="button"
                    design="md link-alt"
                    @click="customClose"
                >
                    Cancelar
                </ui-button>
            </div>

            <ui-button
                v-if="stages.primary && !stages.second"
                type="button"
                design="md success mw-100"
                :disabled="!canSubmit"
                @click="nextStage"
            >
                Continuar
            </ui-button>

            <ui-button
                v-if="!stages.primary && stages.second"
                type="button"
                design="md success mw-100"
                :disabled="!canSubmit"
                @click="submitReserve"
            >
                Confirmar
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
	import { uiNuggetActionsSageStatus, uiNuggetProductForm } from '@/components/ui-facilita/nuggets'
	import { uiDealSelector } from '@/components/ui-facilita/selectors'
	import { uiActionsDealsWrapperList, uiReserveWrapperList } from '@/components/ui-facilita/wrapper'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelectV2, uiSwitch } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'

	import { uiLoaderMessage } from '@/components/ui/loader'
	import { defaultActionList } from './actionList.js'

	import { alertMixin, helpersMixin, loaderMixin, modalMixin, permissionsMixin } from '@/mixins'

	import { deal, reserve } from '@/services/axios'
	import { storage } from '@/services/storage'

	import { mapGetters } from 'vuex'

	const defaultForm = () => ({
		deal: null,
		requesting: null,

		productForm: {
			product: null,
			product_object: null,
			product_type: 'vertical',

			unity: null,
			block: null,
			floor: null,
		},
		productOptions: {
			products: [],
			units: [],
			blocks: [],
			floor: [],
		},

		expireTimes: [],
		expireTime: null,

		info: 'Selecione o empreendimento.',
	})

	const defaultStages = () => ({
		primary: false,
		second: true,
	})

	const defaultLoader = () => ({
		modalLoad: false,
		modalLoadSuccess: false,
		modalLoadFailed: false,
		modalMessage: '',
		modalDescription: '',
	})

	const defaultProductLoader = () => ({
		products: true,
		units: true,
		blocks: true,
		floors: true,
	})

	const defaultDealPayload = {
		sortBy: { value: 'updated_at', dir: 'desc' },
		filter: undefined,
		search: undefined,
		page: 1,
		perPage: 10,
	}

	const componentData = () => ({
		action: 						{							},
		form: 							{ ...defaultForm() 			},
		stages: 						{ ...defaultStages() 		},
		loader: 						{ ...defaultLoader() 		},
		productLoader:  				{ ...defaultProductLoader() },
		actionList: 					[ ...defaultActionList() 	],
		cantSelectDeal: 				true,
		canChangeProductOnDealSelect: 	true,
		actionVisible: 					false,
		iframe: 						false,
		visible: 						true,
		noFinalize: 					false,
		allowedMenu: 					storage .get('allowed_menu'),
		reserveData: 					JSON.parse(storage.get('data_reserve')),
		switchActive: 					false
	})

	export default {
		name: 'ui-select-reserve-modal',

		components: {
			uiModal,
			uiButton,
			uiSelectV2,
			uiSwitch,
			uiReserveWrapperList,
			uiActionsDealsWrapperList,
			uiDealSelector,
			uiNuggetProductForm,
			uiNuggetActionsSageStatus,
			uiLoaderMessage,
		},

		mixins: [loaderMixin, alertMixin, modalMixin, permissionsMixin, helpersMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
			customCloseEvent: {
				type: [String, Array],
				required: false,
				default: ''
			},
		},

		data() {
			return componentData()
		},

		computed: {
			...mapGetters('auth', { user: 'getUser' }),

			successAction() {
				const index = this.actionList.findIndex((action) => action.check == true)

				if (index === -1) return ''
				else return this.actionList[index].action
			},

			canSubmit() {
				if (this.stages.primary)
					return this.form.deal &&
						!Array.isArray(this.form.deal) &&
						this.form.productForm.product &&
						!Array.isArray(this.form.productForm.product) &&
						this.form.productForm.product_object &&
						this.actionStatus

				return (
					this.form.deal &&
					!Array.isArray(this.form.deal) &&
					this.form.productForm.product &&
					!Array.isArray(this.form.productForm.product) &&
					this.form.productForm.product_object &&
					!Array.isArray(this.form.expireTime) &&
					this.form.expireTime &&
					this.getSelectedUnity &&
					this.actionStatus
				)
			},

			actionStatus() {
				return this.action &&
					// eslint-disable-next-line no-prototype-builtins
					this.action.hasOwnProperty('no_action') &&
					this.action.no_action
					? true
					: this.action.action_id
			},

			getSelectedFloor() {
				if (this.getSelectedUnity)
					return this.getSelectedUnity.floor ? this.getSelectedUnity.floor : undefined

				return undefined
			},

			getSelectedBlock() {
				if (this.getSelectedUnity)
					return this.getSelectedUnity.block ? this.getSelectedUnity.block : undefined

				return undefined
			},

			getSelectedUnity() {
				if (!this.getAllUnits) return undefined

				return this.getAllUnits.find((unity) => unity.check)
			},
			showReserved() {
				return this.$store.getters['switchButton/getSwitch']
			},
			getAllUnits: {
				get() {
					if (!this.form.productOptions || !this.form.productOptions.units)
						return undefined

					const unitsFiltered = this.showReserved
						? this.form.productOptions.units.slice()
						: this.form.productOptions.units.filter(
								(unity) => unity.situation == 'available',
						  )

					return unitsFiltered.sort((a, b) => {
						const n1 = parseInt(a.number)
						const n2 = parseInt(b.number)

						if (n1 < n2) return -1
						if (n1 > n2) return 1

						return 0
					})
				},
				set(newVal) {
					return newVal
				},
			},

			modalSize() {
				return this.stages.second ? 'nm' : 'xxxs'
			},

			modalTitle() {
				return 'Solicitar Reserva'
			},
		},

		watch: {
			'form.deal'(newVal, oldVal) {
				if (newVal != oldVal && this.canChangeProductOnDealSelect) {
					if (!newVal || Array.isArray(newVal)) return
					this.$root.$emit('nugget-product-form-select-reserve-modal', newVal)
				}
			},

			'form.productForm.product_object.infos.reserve.times'(newVal) {
				this.form.expireTime  = null
				this.form.expireTimes = []

				// It is only possible to make a reservation if you have an expiration time
				if (!newVal) {
					if (this.form.productForm.product_object)
						this.$mx_alertError('Não existe Tempo de Expiração de reservas cadastrado neste Empreendimento, não será possível realizar nenhuma reserva.')

					return
				}

				newVal.forEach((value) => {
					this.form.expireTimes.push({ time: value })
				})

				this.form.expireTime = this.form.expireTimes[0].time
			},

			'form.productForm.product': {
				handler(newVal) {
					if (!newVal || Array.isArray(newVal)) {
						this.form.info = 'Selecione o empreendimento.'
						return
					}

					this.form.info = ''
				},

				deep: true
			},

			'form.productForm.product_object.availability': {
				handler(newVal) {
					this.switchActive = !newVal?.integration_erp && newVal?.infos?.reserve?.queueReserve?.status === 'active'
				},

				deep: true
			},
		},

		// created() {
		// 	this.allowedMenu = storage.get('allowed_menu')
		// },
		mounted() {
			this.$root.$on('no-finalize-reserve', () => {
				this.noFinalize = true
			})
			this.$root.$on('modal-open-' + this.$mx_getModalName, async (data = null, inSecondStage = true, iframe = false, preSelectedData = null) => {
				this.iframe = iframe
				if (!iframe) {
					this.$root.$emit('set-input-search-select-v3', null, false)
				}
				this.$root.$emit('clean--nugget-actions-stage-status-form-request-reserve-modal')
				this.$root.$emit('nugget-actions-stage-status-form-request-reserve-modal')

				// Who is requesting the reserve? Set this here
				this.form.requesting = this.user.id

				if (!inSecondStage) {
					this.switchStage(true, false)
					return
				}

				let newData = undefined

				if (this.$route.params.deal) {
					newData = await this.getDealById(this.$route.params.deal)

					// Remove option "Visualizar dados do Cliente" if accessing by URI
					this.actionList.shift()
				}
				else newData = data

				if (!newData) {
					this.cantSelectDeal = false

					this.form.info = "Selecione o cliente."
					this.productLoader.units = false

					if (preSelectedData) {
						this.canChangeProductOnDealSelect = false
						this.$root.$emit('nugget-product-form-select-reserve-modal', null, preSelectedData)
					}

					return
				}

				if (!newData.label) {
					let customerName = undefined

					if (newData.customer_name) customerName = newData.customer_name
					else customerName = newData.customer.name

					newData.label = `${newData.id} - ${customerName}`
				}

				/*
   				Gerenciando o modal aberto no contexto da interna do negócio
   				   - Já existe cliente associado: evento de $emit-> 'deal-selector' e 'newData'.
   				   - Há um empreendimento/unidade pré-selecionada: evento de $emit-> 'nugget-product-form-select-reserve-modal' com dados 'preSelectedData'.
				*/
				if(newData && preSelectedData){
					this.productLoader.units = false
					this.canChangeProductOnDealSelect = false
					this.$root.$emit('nugget-product-form-select-reserve-modal', null, preSelectedData)
				}

				// Switch to second stage
				this.switchStage(false, true)
				this.$root.$emit('deal-selector', newData, !this.$route.params.deal)
			})

			this.$root.$on('create-task-custom-close-select-reserve', () => {
				this.visible = true
			})
			window.addEventListener("keydown", event => {
				if(event.keyCode == 27) {
					this.customClose()
				}
			})

			this.$root.$on('has-permissions-details', payload => {
				this.form.info = payload.msg
			})
		},

		beforeDestroy() {
			this.$mx_closeModal()
			this.$root.$off('nugget-actions-stage-status-form-request-reserve-modal')
			this.$root.$off('nugget-product-form-select-reserve-modal')
			this.$root.$off('clean--nugget-actions-stage-status-form-request-reserve-modal')
			this.$root.$off('clean--nugget-product-form-select-reserve-modal')

			this.$root.$off('modal-open-' + this.$mx_getModalName)
			this.$root.$off('create-task-custom-close-select-reserve')
			this.$root.$off("no-finalize-reserve")
		},

		methods: {
			customClose() {
				this.handleClose()
				/**
				 * Emite o evento do Google Analytics
				 */
				this.$gtm.trackEvent({
						event: 'fac_button_click',
						category: 'vuejs-criar-reserva',
						action: 'click',
						label: 'Ação Cancelar List Modal',
					})
				// Emit event to close iframe
				if (this.$route.name == 'global.request.reserve' || this.iframe) {
					const event = new CustomEvent('iframe--request-modal')
					window.parent.document.dispatchEvent(event)
				}
				this.resetAll()
				this.$mx_closeModal()
				this.$root.$emit('clean--nugget-actions-stage-status-form')
				this.$root.$emit('clean--nugget-product-form-select-reserve-modal')

				if (this.customCloseEvent) {
					if (Array.isArray(this.customCloseEvent)) {
						this.customCloseEvent.forEach((event) => {
							this.$root.$emit('select-reserve-' + event)
						})

						return
					}

					this.$root.$emit('select-reserve-' + this.customCloseEvent)
				}
			},

			handleClose(){
				// Comunica para o painel legado, quando o modal foi fechado
				let messagePanel = {modal: 'select-reserve', type: 'close'}
				window.parent.postMessage(messagePanel, '*');
			},

			refreshUnits() {
				// Refresh units
				let updatedDeal = this.form.deal
				updatedDeal.product_availability_id = this.form.productForm.product

				this.$root.$emit('nugget-product-form-select-reserve-modal', updatedDeal)
				this.loader = { ...defaultLoader() }
			},

			successButton() {
				switch (this.successAction) {
					case 'redirect--client': {
						window.open(this.oldPanelLink(`vendas/negocios/${this.form.deal.id}`))
						break
					}
					case 'redirect--make-task': {
						let payload = {}

						if (this.form.deal.owners) {
							const user_name 		= this.user.first_name 																? this.user.first_name 							: ''
							const user_id 			= this.user.id																		? this.user.id 									: ''
							const manager_name 		= this.form.deal.owners.manager && this.form.deal.owners.manager.user.first_name 	? this.form.deal.owners.manager.user.first_name : ''
							const manager_user_id 	= this.form.deal.owners.manager && this.form.deal.owners.manager.user.id			? this.form.deal.owners.manager.user.id 		: ''
							const broker_name 		= this.form.deal.owners.broker  && this.form.deal.owners.broker.user.first_name 	? this.form.deal.owners.broker.user.first_name 	: ''
							const broker_user_id 	= this.form.deal.owners.broker  && this.form.deal.owners.broker.user.id  			? this.form.deal.owners.broker.user.id 			: ''
							const id 				= this.form.deal.id																	? this.form.deal.id 							: ''
							const customer_name 	= this.form.deal.customer.name														? this.form.deal.customer.name 					: ''
							const broker_id 		= this.form.deal.owners.broker_id													? this.form.deal.owners.broker_id 				: ''
							const manager_id 		= this.form.deal.owners.manager_id													? this.form.deal.owners.manager_id 				: ''

							payload = {
								user_name,
								user_id,
								manager_name,
								manager_user_id,
								broker_name,
								broker_user_id,
								id,
								customer_name,
								broker_id,
								manager_id
							}
						}
						else payload = this.form.deal

						this.visible = false
						this.$root.$emit('modal-open-global--create-task', payload, null, true)

						break
					}

					case 'redirect--make-reserve': {
						// Refresh units
						this.refreshUnits()
						break
					}
				}
			},

			async getDealById(id) {
				const isInt = (value) => {
					var x = parseFloat(value);
					return !isNaN(value) && (x | 0) === x;
				}

				if (!isInt(id)) return null

				try {
					let payload = { ...defaultDealPayload }
					payload.filter =
					[
						{ name: 'id', value: id }
					]

					const { data } = await deal.dataTable(payload)
					if (data.status && data.status == 'error') throw new Error(data.msg)

					return data.data[0]
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return null
				}
			},

			async submitReserve() {
				/**
				 * Emite o evento do Google Analytics
				 */
				this.$gtm.trackEvent({
					event: 		'fac_button_click',
					category: 	'vuejs-criar-reserva',
					action: 	'click',
					label: 		'Ação Confirmar List Modal',
				})

				// Can submit?
				if (!this.canSubmit) return

				this.$mx_setLoader('modalLoad', true)
				this.loader.modalMessage = 'Solicitando reserva...'

				try {
					const product_id = this?.form?.productForm?.product_object.id ? this.form.productForm.product_object.id : null
					const reserveCreatePayload = {
						unity_id: 		  this?.getSelectedUnity?.id ? parseInt(this.getSelectedUnity.id) : null,
						reserved_user_id: this?.form?.requesting ? parseInt(this.form.requesting) : null,
						product_id: 	  product_id ? parseInt(product_id)  : null,
						block: 			  this.getSelectedBlock  || null,
						number: 		  this?.getSelectedUnity?.number ? parseInt(this.getSelectedUnity.number) : null,
						deal_id: 		  this?.form?.deal?.id ? parseInt(this.form.deal.id) : null,
					}

					// Has floor selected?
					if (this?.getSelectedFloor)
						reserveCreatePayload['floor'] = this.getSelectedFloor

					// Has an expiration time been selected by the user?
					if (this?.form?.expireTime && !Array.isArray(this.form.expireTime)) {
						reserveCreatePayload['expire_time'] = this.form.expireTime
					}

					let reserveCreateResponse = null

					// Is UAU integration product?
					if (this?.getSelectedUnity?.isUAU) {
						// Painel Legado uses this values
						reserveCreatePayload['integration'] 			= {}
						reserveCreatePayload['integration']['status'] 	= parseInt(this.getSelectedUnity.situation)
						reserveCreatePayload['integration']['product'] 	= parseInt(this.getSelectedUnity.prod_unid)
						reserveCreatePayload['integration']['business'] = parseInt(this.getSelectedUnity.empresa_unid)
						reserveCreateResponse 							= await reserve.create('', reserveCreatePayload)
					}else{
						reserveCreateResponse = await reserve.createV2('', {
							...reserveCreatePayload,
							action_id: this.action.action_id,
						})
					}

					if (reserveCreateResponse.data.status == 'error') {
						throw new Error(reserveCreateResponse.data.msg)
					}

					// Got in the queue
					if (
						reserveCreateResponse?.data?.status == 'success' && reserveCreateResponse?.data?.msg &&
						!['O registro foi criado com sucesso!', 'Operação concluída com sucesso.'].includes(reserveCreateResponse.data.msg)) {
						this.$mx_alertNotice(reserveCreateResponse.data.msg)
					}

					const dealCreatePayload = {
						unity: 			parseInt(this.getSelectedUnity.id),
						product_name: 	this.getSelectedUnity.title,
						cost: 			parseInt(this.getSelectedUnity.cost),
					}

					// Is UAU integration product?
					if (this.getSelectedUnity.isUAU) {
						delete dealCreatePayload['cost']
					}

					await deal.create(`reservation/${this.form.deal.id}`, dealCreatePayload)

					setTimeout(() => {
						const dealUpdatePayload = {
							product_id: parseInt(product_id),
							unity_id: parseInt(this.getSelectedUnity.id),
							cost: parseInt(this.form.deal.cost),
						}

						// Is UAU integration product?
						if (this?.getSelectedUnity?.isUAU) {
							delete dealUpdatePayload['unity_id']
							delete dealUpdatePayload['cost']
							dealUpdatePayload['options'] = `${this.getSelectedBlock}@${this.getSelectedUnity.id}`
						}

						if (this?.action?.no_action && this?.reserveData) {
							dealUpdatePayload['funnel_stage_id'] 		= this.reserveData.stage
							dealUpdatePayload['funnel_stage_status_id'] = this.reserveData.status
						}

						const dealUpdateResponse = deal.update(
							'',
							this.form.deal.id,
							dealUpdatePayload,
						)
						if (dealUpdateResponse?.data?.status == 'error') {
							throw new Error(dealUpdateResponse.data.msg)
						}

						this.noFinalize ? this.closeAnimationToCustomers() : this.closeAnimation()
						this.handleClose()
					}, 500)

				} catch (error) {
					this.$mx_setLoader('modalLoad', true)
					this.loader.modalMessage 	 = 'Ocorreu um erro!'
					this.loader.modalDescription = error.data.msg
					this.$mx_setLoader('modalLoadFailed', true)
				}
			},

			nextStage() {
				/**
				 * Emite o evento do Google Analytics
				 */
				this.$gtm.trackEvent({
					event: 		'fac_button_click',
					category: 	'vuejs-criar-reserva',
					action: 	'click',
					label: 		'Ação Continuar List Modal',
				})

				if (!this.form.deal.label)
					this.form.deal.label = `${this.form.deal.id} - ${this.form.deal.customer_name}`

				this.switchStage(false, true)
			},

			switchStage(primary, second) {
				this.stages.primary = primary
				this.stages.second 	= second
			},
			closeAnimationToCustomers() {
				setTimeout(() => {
					this.loader.modalMessage = 'Reserva criada com sucesso!'
					this.$mx_setLoader('modalLoadSuccess', true)
					setTimeout(() => {
					 	this.customClose()
					 }, 1500);
				},	300)
			},
			closeAnimation() {
				setTimeout(() => {
					this.loader.modalMessage 	 = 'Reserva criada com sucesso!'
					this.loader.modalDescription = 'O que deseja fazer agora?'
					this.$mx_setLoader('modalLoadSuccess', true)
				}, 500)
			},

			resetAll() {
				this.$root.$emit('select2-cancel-event-request-reserve')
				Object.assign(this.$data, componentData())
			},

			callCreateDealModal() {
				if (this.iframe) {
					this.$root.$emit('modal-open-global--create-deal-modal', null, true, true)
					return
				}

				this.$root.$emit('modal-open-create-deal-modal', null, true, false)
			},

            checkMenuAllowed(name){
                return this.allowedMenu.includes(name)
            },

			showReservedInput (bool) {
				this.$store.dispatch('switchButton/setSwitch', bool)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
